export default __webpack_public_path__ + "static/eng-0cf23692e007a8abba97f2ea6a8dc598.jpeg";